module.exports = {
    debug: true,
    realtime: {
        tokenUrl: 'https://staging.lordgunbicycles.com/webapi/realtime/api/Token',
        paymentHubUrl: 'https://staging.lordgunbicycles.com/webapi/realtime/paymenthub',
        username: 'Admin',
        password: 'SignalR2020',
    },
    useCdn: false,
    cdnImagesUrl: 'https://d3n8mmvj9ns1ml.cloudfront.net',
    cdnImagesFallbackUrl: 'https://sync.lordgunbicycles.com:4433',
    cdnCmsAssetsUrl: 'https://d2umopxfu128sk.cloudfront.net',
    supportedCultures: () => [
        'it-IT',
        'es-ES',
        'fr-FR',
        'en-GB',
        'en-US',
        'de-DE',
        'en-AU',
        'ko-KR',
    ],
    cms: {
        cmsUrl: 'https://lnxtest.lordgunbicycles.com',
    },
    tracingUrl:
        'https://6f569c242a3a4173b354adf56020c011@o245932.ingest.sentry.io/5905368',
};
